// extracted by mini-css-extract-plugin
export var container = "_d7-0";
export var icon = "_d7-1";
export var text = "_d7-2";